



























import ListItem from '@/components/list/ListItem.vue'
import MainLayout from '@/layouts/default/MainLayout.vue'
import HeaderLayout from '@/components/Header.vue'
import Translation from '@/mixins/Translation'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import {TranslateResult} from 'vue-i18n'
import {namespace} from 'vuex-class'
import {Divider} from 'element-ui'

const auth = namespace('auth')

interface Item {
  type: string
  title: string | TranslateResult
  rightIcon: string
  to: string
  hasDivider: boolean
}

/**
 * @displayName SettingPage
 */
@Component({
  components: {ListItem, HeaderLayout, MainLayout, [Divider.name]: Divider},
})
export default class SettingPage extends Mixins(Translation) {
  @Prop({default: 0, type: Number}) windowScrollY: number
  @Prop({default: 'terms', type: String}) translation: string

  @auth.State('id') userId: string

  get feedbackPageLink() {
    return `https://heum.typeform.com/to/MVS6SIGa#code=${this.userId}`
  }

  get list(): Item[] {
    const {ts} = this
    return [
      {title: `${ts('my')} ${ts('info')}`, rightIcon: 'arrow-right-sm', to: 'user', type: 'router', hasDivider: true},
      {title: `${ts('enabling')} ${ts('management')}`, rightIcon: 'arrow-right-sm', to: 'cert-center', type: 'router', hasDivider: false},
      // {title: ts('bank-account'), rightIcon: 'arrow-right-sm', to: 'banks', type: 'router', hasDivider: false},
      {title: `${ts('user')} ${ts('management')}`, rightIcon: 'arrow-right-sm', to: 'user-center', type: 'router', hasDivider: true},
      {title: `${ts('notification')} ${ts('setting')}`, rightIcon: 'arrow-right-sm', to: 'noti', type: 'router', hasDivider: false},
      {title: ts('notice'), rightIcon: 'arrow-right-sm', to: 'notice', type: 'router', hasDivider: false},
      {title: '의견 남기기', rightIcon: 'arrow-right-sm', to: this.feedbackPageLink, type: 'link', hasDivider: false},
    ]
  }

  created() {
    this.replaceRoute()
  }

  replaceRoute() {
    const {replace} = this.$route.params
    const stayTime = 500
    if(replace) {
      setTimeout(() => {
        this.$router
          .push({name: replace})
          .catch((err) => err)
      }, stayTime)
    }
  }

  onClick(item) {
    if(item.type === 'router') this.movePage(item.to)
    else if(item.type === 'link') this.openNewWindow(item.to)
  }

  movePage(routerName) {
    this.$router
      .push({name: routerName})
      .catch((err) => err)
  }

  openNewWindow(url) {
    window.open(url, '_blank')
  }
}
